export default __webpack_public_path__ + "static/sac.en.cover-99989792a9a67c855e485ca20b41f0e8.jpg";